// MATERIAL
import { Typography as MuiTypography } from "@mui/material";
import { styled } from "@mui/material/styles";

export const Typography = styled(MuiTypography)({
  fontSize: 22,
  fontWeight: 900,
  lineHeight: "26px",
});
